import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static values = { closeOnSubmit: { type: Boolean, default: true } }

  connect(){
    this.showModal()
  }

  submitEnd(e) {
    if (e.detail.success && this.closeOnSubmitValue) {
      this.hideModal()
    }
  }

  showModal(){
    this.modal = new bootstrap.Modal(this.element)
    this.modal.show()
  }

  hideModal(){
    this.modal.hide()
  }

  cleanup() {
    this.modal?.hide()
    this.modal?.dispose()
    this.modal = null
  }

  disconnect() {
    this.cleanup()
  }
}
